export const maxClappers = 4
export const maxHeightBreakpoint1 = `360px`
export const maxHeightBreakpoint2 = `480px`
